import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
interface WorkflowSettingTabsProps {
  value: number;
  handleChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const WorkflowSettingTabs = ({
  value,
  handleChange,
}: WorkflowSettingTabsProps) => {
  return (
    <Tabs
      orientation="vertical"
      value={value}
      onChange={handleChange}
      sx={{
        borderRight: 1,
        borderColor: "#76CFEB33",
        alignItems: "flex-start",
        height: "100%",
        "& .MuiTab-root": {
          color: "var(--Main_icons_color)",
          textTransform: "unset",
          fontFamily: "Roboto",
          fontWeight: "500",
          fontSize: "14px",
          lineHeight: "20px",
          letterSpacing: "0.1px",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          opacity: "0.7",
          "&:hover": {
            opacity: "1",
          },
        },
        "& .Mui-selected": {
          color: "#12B6EA !important",
          opacity: "1",
        },
      }}
      TabIndicatorProps={{
        style: { display: "none" },
      }}
    >
      <Tab
        className="workflow-parameter-item"
        label="Input type"
        disableRipple
      />
      <Tab className="workflow-parameter-item" label="Settings" disableRipple />
      <Tab
        className="workflow-parameter-item"
        label="Output type"
        disableRipple
      />
    </Tabs>
  );
};

export default WorkflowSettingTabs;
